/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonApiEventParty,
    JsonApiEventPartyFromJSON,
    JsonApiEventPartyFromJSONTyped,
    JsonApiEventPartyToJSON,
} from './JsonApiEventParty';

/**
 * 
 * @export
 * @interface ApiResultOfJsonApiEventParty
 */
export interface ApiResultOfJsonApiEventParty {
    /**
     * 
     * @type {JsonApiEventParty}
     * @memberof ApiResultOfJsonApiEventParty
     */
    data?: JsonApiEventParty;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonApiEventParty
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonApiEventParty
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonApiEventParty
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonApiEventParty
     */
    result?: ApiResultOfJsonApiEventPartyResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonApiEventPartyResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonApiEventPartyFromJSON(json: any): ApiResultOfJsonApiEventParty {
    return ApiResultOfJsonApiEventPartyFromJSONTyped(json, false);
}

export function ApiResultOfJsonApiEventPartyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonApiEventParty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonApiEventPartyFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonApiEventPartyToJSON(value?: ApiResultOfJsonApiEventParty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonApiEventPartyToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

